import { PAYMENTCHECKOUTDETAILS } from '../actionTypes';
import CONSTANTS from '../constants';

const initialState = {
  payments: [],
  paymentCheckoutDetailsStatus: undefined,
  paymentCheckoutDetailsError: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case PAYMENTCHECKOUTDETAILS.FETCH:
      return {
        ...state,
        paymentCheckoutDetailsStatus: CONSTANTS.API_STATUS.STARTED,
      };
    case PAYMENTCHECKOUTDETAILS.SUCCESS:
      return {
        ...state,
        ...action.payload,
        paymentCheckoutDetailsStatus: CONSTANTS.API_STATUS.SUCCEEDED,
      };
    case PAYMENTCHECKOUTDETAILS.FAILED:
      return {
        ...state,
        paymentCheckoutDetailsError: action.payload,
        paymentCheckoutDetailsStatus: CONSTANTS.API_STATUS.FAILED,
      };
    case PAYMENTCHECKOUTDETAILS.PAYMENTS_SUCCESS:
      return {
        ...state,
        payments: action.payload,
      };
    default:
      return state;
  }
};
